import { render, staticRenderFns } from "./CourseInfo.vue?vue&type=template&id=87022dd8&"
import script from "./CourseInfo.vue?vue&type=script&lang=js&"
export * from "./CourseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CourseInfoPhysical: require('/opt/build/repo/components/CourseInfoPhysical.vue').default,CourseInfoVirtual: require('/opt/build/repo/components/CourseInfoVirtual.vue').default})
